(function () {
  function initMissionCommunity(root) {
    if (!root || root.dataset.mcInit === 'true') return;
    root.dataset.mcInit = 'true';

    root.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-mission-toggle]');
      if (!toggle) return;

      var group = toggle.closest('[data-mission-row-group]');
      var detail = group ? group.querySelector('[data-mission-detail]') : null;
      if (!detail) return;

      var isOpen = toggle.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        detail.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        detail.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mission-community]').forEach(initMissionCommunity);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mission-community]');
    if (root) {
      root.dataset.mcInit = 'false';
      initMissionCommunity(root);
    }
  });
})();
